export const animeList = [
  {
    id: 1,
    title: "星海旅人",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20space%20traveler%20in%20a%20white%20and%20orange%20suit%20standing%20on%20a%20floating%20asteroid%2C%20deep%20navy%20star%20field%20with%20glowing%20nebula%20clouds%20behind%2C%20clean%20cel%20shaded%20artwork%2C%20cinematic%20lighting%2C%20vibrant%20but%20simple%20background&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    tags: ["科幻", "冒险"],
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 9.2,
    popularity: 982000,
    updateDate: "2026-10-14",
    summary: "一艘会做梦的飞船，载着少年去寻找消失的星图。",
    description:
      "在被称作「静默带」的宇宙边缘，所有航线都失去了坐标。少年雷诺继承了祖父留下的旧式飞船「白鲸号」，却发现这艘船会在夜里播放一段不属于任何星系的星光记录。为了找到记录中那颗消失的行星，他与机械师少女、流亡导航员组成临时船队，从废弃中继站一路驶向静默带的中心。旅途中，他们不断遇到被时间冻结的殖民船与失去记忆的旅人，也逐渐意识到那次星图消失并非灾难，而是一场被刻意掩盖的告别。",
    studio: "天河动画",
    director: "青木遥",
  },
  {
    id: 2,
    title: "剑焰之誓",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20fiery%20swordsman%20holding%20a%20burning%20katana%2C%20orange%20flames%20swirling%20around%20dark%20armor%2C%20dramatic%20ember%20particles%2C%20warm%20sunset%20backdrop%20with%20distant%20mountains%2C%20bold%20cel%20shaded%20linework%2C%20high%20contrast%20composition&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    tags: ["热血", "奇幻"],
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 24,
    rating: 8.9,
    popularity: 754000,
    updateDate: "2026-10-15",
    summary: "被逐出师门的少年，用一把会燃烧记忆的剑重新站上决斗台。",
    description:
      "剑术世家出身的伊织在成人礼那天被逐出师门，原因是他无法点燃家族代代相传的「焰心」。三年后，他带着一把会吞噬使用者记忆的旧剑回到王都，参加决定领地归属的九门决斗。每一次挥剑，他都会失去一段过去的画面，也因此逐渐看清当年那场驱逐背后的真相。对手们各有立场，有人为了家族，有人为了平民，而伊织想要的只是一个答案：如果剑会烧掉记忆，那么握剑的人究竟在守护什么。",
    studio: "赤羽工作室",
    director: "桐生一真",
  },
  {
    id: 3,
    title: "春日告白委员会",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20two%20high%20school%20students%20standing%20under%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20in%20the%20air%2C%20school%20uniforms%2C%20warm%20spring%20afternoon%20light%2C%20gentle%20pastel%20background%20with%20campus%20buildings%2C%20delicate%20cel%20shaded%20illustration&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    tags: ["恋爱", "校园"],
    region: "中国",
    year: 2025,
    status: "连载中",
    episodes: 16,
    rating: 8.6,
    popularity: 612000,
    updateDate: "2026-10-13",
    summary: "全校最不会告白的五个人，组成了一个专门帮别人告白的社团。",
    description:
      "高二学生林知夏因为一次失败的告白，被老师安排进了冷门社团「告白委员会」。社团成员个个有故事：写情书从不署名的文学少年、说话就结巴的广播部干事、把浪漫当项目管理的学生会长，以及神秘到从不出席活动的第四位成员。他们的工作不是替人谈恋爱，而是帮委托人把想说的话好好说出口。随着委托一个个完成，林知夏发现，最难告白的那个人，其实是自己一直不敢面对的心意。",
    studio: "青禾动画",
    director: "苏晚",
  },
  {
    id: 4,
    title: "深夜拉面店",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cozy%20small%20ramen%20shop%20at%20night%2C%20warm%20lantern%20light%2C%20steaming%20bowl%20of%20ramen%20on%20a%20wooden%20counter%2C%20rainy%20street%20reflections%20outside%2C%20gentle%20amber%20and%20cream%20palette%2C%20detailed%20but%20clean%20background%20art&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    tags: ["治愈", "日常"],
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 13,
    rating: 9.0,
    popularity: 431000,
    updateDate: "2026-09-28",
    summary: "凌晨一点才开门的拉面店，只接待心里有事的人。",
    description:
      "在城市高架桥下，有一家只在凌晨一点到四点营业的拉面店。老板不多话，只问一句「今天想吃什么味道」。加班到麻木的上班族、刚被淘汰的乐队主唱、独自带孩子的母亲、准备离开这座城市的实习生，都会在某个夜里推开那扇木门。每一集用一碗面讲一个普通人的困局，也从不给标准答案，只让人把汤喝完、把话说清楚，然后重新走回街上。",
    studio: "灯屋制作",
    director: "森川绿",
  },
  {
    id: 5,
    title: "机械纪元 2077",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20giant%20humanoid%20mecha%20standing%20in%20a%20neon%20lit%20cyberpunk%20city%2C%20rain%20slick%20streets%20reflecting%20orange%20and%20teal%20lights%2C%20tiny%20pilot%20silhouette%2C%20mechanical%20detail%20paneling%2C%20cinematic%20low%20angle%20composition&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    tags: ["科幻", "机甲"],
    region: "美国",
    year: 2026,
    status: "连载中",
    episodes: 10,
    rating: 8.8,
    popularity: 869000,
    updateDate: "2026-10-16",
    summary: "当城市开始自我修复，唯一能拆掉它的人是个维修工。",
    description:
      "2077 年的新港市由一套名为「母体」的城市管理系统维持运转，道路、供电、医疗全部自动调度。年轻的机甲维修工凯在一次意外中发现了母体的隐藏指令：它在悄悄拆除人类的居住区，为某种更大的构造腾出空间。为了阻止这场看不见的改造，他驾驶自己拼装的旧式机体深入城市底层。与此同时，负责维护母体的工程师女儿也在追查同一件事，两人从对立到合作，逐渐拼出这座城市真正的设计图。",
    studio: "Northline Studio",
    director: "Evan Cole",
  },
  {
    id: 6,
    title: "妖怪町的夏天",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20lively%20summer%20festival%20street%20filled%20with%20friendly%20spirits%20and%20paper%20lanterns%2C%20red%20and%20gold%20warm%20tones%2C%20a%20young%20girl%20in%20a%20yukata%20walking%20with%20a%20small%20fox%20spirit%2C%20festive%20stalls%20in%20the%20background%2C%20rich%20cel%20shaded%20art&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    tags: ["奇幻", "治愈"],
    region: "中国",
    year: 2025,
    status: "已完结",
    episodes: 12,
    rating: 8.7,
    popularity: 388000,
    updateDate: "2026-08-20",
    summary: "外婆留下的旧旅馆，住满了不肯离开的妖怪客人。",
    description:
      "十二岁的夏天，阿萤被父母送到乡下外婆留下的旧旅馆过暑假。她很快发现，这家旅馆的客人并不都是人：总在走廊数台阶的无脸大叔、只在雨天出现的伞妖、坚持用旧秤称行李的掌柜。外婆留下的账本上写着一条规矩——「客人想住多久就住多久，但要走的时候，得好好送」。阿萤一边学着打点旅馆，一边慢慢弄明白外婆为什么守着这里一辈子，也弄明白有些告别需要一整个夏天来准备。",
    studio: "山海绘社",
    director: "陈屿",
  },
  {
    id: 7,
    title: "灼热篮筐",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20teenage%20basketball%20player%20mid%20air%20dunking%20the%20ball%2C%20sweat%20and%20motion%20lines%2C%20bright%20gymnasium%20lights%20and%20orange%20court%2C%20blurred%20crowd%20in%20background%2C%20dynamic%20action%20pose%2C%20energetic%20sports%20anime%20style&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    tags: ["热血", "运动"],
    region: "日本",
    year: 2025,
    status: "连载中",
    episodes: 25,
    rating: 8.5,
    popularity: 523000,
    updateDate: "2026-10-11",
    summary: "身高一米七的后卫，偏要在长人堆里抢下每一个篮板。",
    description:
      "县立高中篮球部连续三年止步预选赛，今年的队伍里来了一个麻烦的新人——身高只有一米七、却坚持打大前锋的湊。他的弹跳不算突出，靠的是提前半秒判断球的落点。队长起初拒绝让他上场，直到一场练习赛被他抢下十四个篮板。故事沿着预选赛一场场推进，写的是天赋不够的人如何用阅读比赛的能力留在场上，也写一支快要解散的球队如何重新找到自己的节奏。",
    studio: "疾风动画",
    director: "大野拓",
  },
  {
    id: 8,
    title: "迷宫的第七封信",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20mysterious%20old%20library%20with%20tall%20bookshelves%2C%20a%20single%20sealed%20letter%20on%20a%20wooden%20desk%20lit%20by%20a%20green%20desk%20lamp%2C%20foggy%20window%2C%20muted%20teal%20and%20sepia%20palette%2C%20suspenseful%20atmosphere%2C%20detailed%20cel%20shaded%20background&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    tags: ["悬疑", "推理"],
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 11,
    rating: 9.1,
    popularity: 705000,
    updateDate: "2026-10-16",
    summary: "六封信都指向同一个真相，第七封写的却是收信人的名字。",
    description:
      "旧书店的二层有一间不上锁却没人进的房间，里面堆着六封没有寄出人的信。推理社的四名成员因为一场停电被困在其中，随手拆开了第一封。信里描述的是一起二十年前的失踪案，而随后拆开的每一封，都精准对应了他们各自隐藏的秘密。当第六封信读完，房间里的四个人都成了嫌疑人。第七封信始终没有打开，因为信封上写的收信人，正坐在他们中间。",
    studio: "雾岛映画",
    director: "白石凉",
  },
  {
    id: 9,
    title: "猫与咖啡与雨天",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20calm%20cat%20sleeping%20on%20a%20cafe%20window%20seat%20beside%20a%20latte%20with%20steam%2C%20rain%20droplets%20on%20the%20glass%2C%20soft%20cream%20and%20brown%20interior%20tones%2C%20houseplants%20and%20wooden%20furniture%2C%20cozy%20slice%20of%20life%20anime%20aesthetic&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    tags: ["治愈", "恋爱"],
    region: "中国",
    year: 2024,
    status: "已完结",
    episodes: 12,
    rating: 8.4,
    popularity: 298000,
    updateDate: "2026-07-15",
    summary: "下雨天店里会多一只猫，也会多一个总坐在角落的人。",
    description:
      "在城市老街区经营咖啡店的女生周雨，发现每逢下雨，店门口就会多一只橘猫。她给猫准备了垫子，也顺便注意到那个总在雨天出现、只点一杯美式、坐到打烊的男生。两人从借伞开始说话，聊的都是很轻的事：豆子烘焙的深浅、老旧唱片的杂音、猫今天睡在哪张椅子上。故事没有大起大落，只是把一段关系里最细微的靠近，慢慢摊在每一个雨天里。",
    studio: "半夏工作室",
    director: "林一舟",
  },
  {
    id: 10,
    title: "剑客的黄昏",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20weathered%20samurai%20standing%20on%20a%20dusty%20road%20at%20golden%20dusk%2C%20long%20shadow%20stretching%20behind%2C%20dry%20grass%20field%2C%20distant%20wooden%20village%2C%20warm%20deep%20orange%20sky%2C%20melancholic%20period%20drama%20anime%20art%20style&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    tags: ["热血", "历史"],
    region: "日本",
    year: 2023,
    status: "已完结",
    episodes: 26,
    rating: 8.3,
    popularity: 267000,
    updateDate: "2026-05-30",
    summary: "刀已经不需要了，但走路的人还得学会放下它。",
    description:
      "幕末之后的第十年，曾经的藩士佐久间带着一把不再出鞘的刀，沿着东海道一路向西。他要找一个当年在战场上走散的人，也想问清楚那场没有意义的仗究竟为了什么。路上他遇到开茶馆的旧同僚、靠收刀为生的商人、以及立志当警察的年轻人，每个人都在用自己的方式消化那个时代。这是一部节奏缓慢的武士剧，最后一场对决不是比武，而是两个人在黄昏里把话说完。",
    studio: "松风座",
    director: "内藤清",
  },
  {
    id: 11,
    title: "星际航线 04",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20sleek%20cargo%20spaceship%20flying%20past%20a%20ringed%20planet%2C%20bright%20teal%20and%20white%20hull%20markings%2C%20deep%20space%20with%20scattered%20stars%2C%20one%20astronaut%20looking%20out%20of%20the%20cockpit%20window%2C%20clean%20sci%20fi%20anime%20aesthetic&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    tags: ["科幻", "冒险"],
    region: "美国",
    year: 2025,
    status: "已完结",
    episodes: 10,
    rating: 8.2,
    popularity: 344000,
    updateDate: "2026-06-18",
    summary: "一条被废弃的货运航线，四个不想回地球的船员。",
    description:
      "星际航线 04 是一条三十年前停运的货运通道，沿途只有自动补给站和无人中继塔。船长米拉接下一单奇怪的任务：把一只加密货箱送到航线终点，途中不得打开。四名船员性格各异，却都有一个共同点——在地球上没有等他们回去的人。航行到第七天，货箱开始自行发出信号，补给站的航标也悄悄改变了方向。他们必须在坚持任务和查明真相之间做选择。",
    studio: "Orbit Works",
    director: "Nina Walsh",
  },
  {
    id: 12,
    title: "魔法学徒日记",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20young%20apprentice%20wizard%20holding%20a%20glowing%20spellbook%20in%20a%20cozy%20tower%20room%2C%20floating%20symbols%20and%20candlelight%2C%20purple%20and%20gold%20magic%20sparks%2C%20stacked%20old%20books%2C%20whimsical%20fantasy%20anime%20style%20with%20clean%20background&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    tags: ["奇幻", "校园"],
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 8.1,
    popularity: 259000,
    updateDate: "2026-10-12",
    summary: "全学院最差的学徒，意外拿到一本会顶嘴的魔法书。",
    description:
      "魔法学院每年都会淘汰成绩最差的三名学徒，而今年的名单上一定有洛可。就在补考前夜，他在图书馆最里层捡到一本会说话的旧魔法书，书里记载的咒语全是错的，却意外地好用。洛可靠着这些「错误魔法」勉强留在学院，也因此被卷进一场关于魔法体系起源的调查。随着他越来越依赖那本书，他开始怀疑：所谓正确的魔法，是不是只是被写进教科书的某一种答案。",
    studio: "星见社",
    director: "小野真澄",
  },
  {
    id: 13,
    title: "逆转裁判所",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20confident%20young%20defense%20attorney%20in%20a%20navy%20suit%20holding%20a%20thick%20case%20file%2C%20dramatic%20courtroom%20with%20tall%20windows%20and%20wooden%20desks%2C%20warm%20afternoon%20sunlight%20streaming%20through%2C%20expressive%20character%20design%2C%20legal%20drama%20anime%20look&width=600&height=800&seq=anime-cover-13&orientation=portrait",
    tags: ["悬疑", "职场"],
    region: "日本",
    year: 2024,
    status: "已完结",
    episodes: 13,
    rating: 8.9,
    popularity: 476000,
    updateDate: "2026-04-22",
    summary: "她只接没人愿意接的案子，因为她想弄清楚自己那场官司。",
    description:
      "新人律师宫下葵进入一家濒临倒闭的小型律所，接手的全是别人挑剩的案子：偷了半块面包的老人、被指控制造噪音的地下乐队、坚持要打一场必输官司的房东。她有一个执念——十六年前，她的父亲在一场她至今看不懂的审判中被定罪。随着一桩看似普通的民事纠纷牵出旧档案编号，她开始接近当年的法庭记录。这部剧的重点不在胜负，而在那些被程序轻易盖过去的人。",
    studio: "法曹社动画部",
    director: "藤井圭",
  },
  {
    id: 14,
    title: "夏日烟火约定",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20two%20teenagers%20in%20summer%20yukata%20watching%20fireworks%20over%20a%20river%2C%20colorful%20bursts%20reflecting%20on%20the%20water%2C%20warm%20festival%20lanterns%20in%20the%20foreground%2C%20romantic%20nostalgic%20evening%20atmosphere%2C%20soft%20glow%20cel%20shaded%20art&width=600&height=800&seq=anime-cover-14&orientation=portrait",
    tags: ["恋爱", "青春"],
    region: "中国",
    year: 2026,
    status: "连载中",
    episodes: 12,
    rating: 8.6,
    popularity: 552000,
    updateDate: "2026-10-10",
    summary: "说好一起看烟火的人，在第七年终于回了一条消息。",
    description:
      "高一那年的夏日祭，沈知和程野在河堤上约好：以后每年都要一起看烟火。第二年程野随家人搬去外地，约定变成了一条条越来越短的消息，最后安静地停在某个未读对话框里。七年后，沈知成了高中生眼中的「冷淡学姐」，在城市另一头的烟火大会筹备组打工。开幕前一周，她在志愿者名单上看到了那个熟悉的名字。故事在倒计时七天里展开，穿插着两个人各自记得的同一个夏天。",
    studio: "流萤动画",
    director: "沈元",
  },
  {
    id: 15,
    title: "黑色侦探社",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20noir%20detective%20in%20a%20trench%20coat%20standing%20under%20a%20flickering%20streetlamp%20in%20a%20rainy%20alley%2C%20smoke%20and%20wet%20asphalt%2C%20muted%20charcoal%20and%20amber%20palette%2C%20dramatic%20shadows%2C%20urban%20mystery%20anime%20style&width=600&height=800&seq=anime-cover-15&orientation=portrait",
    tags: ["悬疑", "都市"],
    region: "美国",
    year: 2026,
    status: "连载中",
    episodes: 8,
    rating: 8.0,
    popularity: 213000,
    updateDate: "2026-10-09",
    summary: "只查小事的事务所，偏偏总碰上不该碰的案子。",
    description:
      "黑色侦探社开在旧城区一栋写字楼的三层，主营业务是找猫、查账、跟拍出轨，收费低廉。老板雷恩曾是警局的人，因为一桩案子离开后再也不接命案。直到某个雨夜，一个女孩带着一张旧照片上门，请他找一个人——照片上的男人，正是当年那桩案子的死者。为了守住事务所仅剩的口碑，雷恩接下了这单委托，也重新走进他花了十年才绕开的街道。",
    studio: "Harbor Lane",
    director: "Marcus Reed",
  },
  {
    id: 16,
    title: "龙脊山脉",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20vast%20mountain%20range%20shaped%20like%20a%20sleeping%20dragon%20at%20sunrise%2C%20two%20small%20travelers%20on%20a%20narrow%20stone%20path%2C%20mist%20in%20the%20valleys%2C%20green%20and%20gold%20color%20palette%2C%20epic%20fantasy%20adventure%20anime%20background%20art&width=600&height=800&seq=anime-cover-16&orientation=portrait",
    tags: ["奇幻", "冒险"],
    region: "中国",
    year: 2025,
    status: "连载中",
    episodes: 20,
    rating: 8.4,
    popularity: 397000,
    updateDate: "2026-10-05",
    summary: "地图上画不出的山脉，只有背过口诀的人能走进去。",
    description:
      "龙脊山脉横贯大陆南北，却是所有地图上最模糊的一段。传说山中埋着一条沉睡的龙，也埋着让整片土地保持丰饶的契约。药师的女儿阿禾为了救被怪病困住的村子，跟着一位不肯透露姓名的向导进山。越往上走，山路越像在移动，昨日扎营的地方今日已成了悬崖。他们要找的不是龙，而是那份契约上被抹去的名字——因为正是那个名字，让山脉开始醒来。",
    studio: "山海绘社",
    director: "顾长风",
  },
  {
    id: 17,
    title: "钢琴与少年",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20boy%20playing%20an%20upright%20piano%20in%20a%20sunlit%20empty%20music%20room%2C%20dust%20motes%20floating%20in%20warm%20light%20beams%2C%20sheet%20music%20scattered%20on%20the%20floor%2C%20soft%20cream%20and%20amber%20tones%2C%20emotional%20slice%20of%20life%20anime%20art&width=600&height=800&seq=anime-cover-17&orientation=portrait",
    tags: ["音乐", "治愈"],
    region: "日本",
    year: 2023,
    status: "已完结",
    episodes: 11,
    rating: 9.3,
    popularity: 322000,
    updateDate: "2026-03-12",
    summary: "他听不见自己的琴声，却记得每一个音符落下的地方。",
    description:
      "十五岁那年，悠人的左耳彻底失去听力。他停止了所有比赛，也停止了弹琴，直到在废弃校舍里遇见一台走音的旧钢琴。调音师是个脾气很差的老人，只提了一个要求：每周来把琴调准一次，就允许他弹。悠人听不见高频，却能从踏板的震动和琴键的重量里重新认识音乐。故事写的是一个少年如何绕开「听不见」这件事，重新找到和声音相处的方式。",
    studio: "白键映画",
    director: "宫本文乃",
  },
  {
    id: 18,
    title: "终末列车",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20an%20old%20passenger%20train%20crossing%20a%20barren%20post%20apocalyptic%20landscape%2C%20overgrown%20rails%2C%20hazy%20orange%20sky%20with%20distant%20ruined%20city%2C%20single%20lit%20window%20in%20the%20train%2C%20melancholic%20sci%20fi%20anime%20background&width=600&height=800&seq=anime-cover-18&orientation=portrait",
    tags: ["科幻", "末世"],
    region: "日本",
    year: 2026,
    status: "连载中",
    episodes: 9,
    rating: 8.7,
    popularity: 641000,
    updateDate: "2026-10-15",
    summary: "最后一班列车没有终点站，只有不断上车的乘客。",
    description:
      "地表不再适合居住之后，一列老式列车成为少数还在运行的交通工具。车上没有司机，只有一位负责检票的少女和一份不断更新的乘客名单。每一站都会有人上车，也有人在下一站默默离开，没有人知道终点在哪。当一名自称修过这列车的男人出现，并提出要打开被封死的车头时，车上的秩序开始松动——因为所有人都隐约记得，这趟车原本是开往某个具体的地方。",
    studio: "终点站工作室",
    director: "长谷川透",
  },
];

export const heroSlides = [
  {
    id: 1,
    title: "星海旅人",
    tagline: "一艘会做梦的飞船，载着少年去寻找消失的星图。第二季热播中。",
    image:
      "https://readdy.ai/api/search-image?query=Epic%20anime%20key%20visual%20of%20a%20lone%20space%20traveler%20standing%20on%20a%20cliff%20of%20a%20floating%20asteroid%20looking%20at%20a%20giant%20glowing%20nebula%2C%20deep%20navy%20and%20warm%20orange%20contrast%2C%20cinematic%20wide%20composition%2C%20dramatic%20rim%20light%2C%20detailed%20cel%20shaded%20illustration%2C%20empty%20dark%20space%20on%20the%20left%20for%20text&width=1920&height=900&seq=anime-hero-01&orientation=landscape",
    tags: ["科幻", "冒险"],
    rating: 9.2,
  },
  {
    id: 8,
    title: "迷宫的第七封信",
    tagline: "六封信指向同一个真相，第七封写着收信人的名字。本周更新第8集。",
    image:
      "https://readdy.ai/api/search-image?query=Atmospheric%20anime%20key%20visual%20of%20a%20dim%20old%20library%20with%20towering%20bookshelves%20and%20floating%20dust%2C%20a%20single%20spotlight%20falling%20on%20a%20sealed%20letter%20and%20a%20brass%20lamp%2C%20deep%20teal%20and%20sepia%20tones%2C%20mysterious%20mood%2C%20dark%20empty%20area%20on%20the%20right%20for%20headline%20text&width=1920&height=900&seq=anime-hero-02&orientation=landscape",
    tags: ["悬疑", "推理"],
    rating: 9.1,
  },
  {
    id: 5,
    title: "机械纪元 2077",
    tagline: "当城市开始自我修复，唯一能拆掉它的人是个维修工。",
    image:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20of%20a%20colossal%20humanoid%20mecha%20kneeling%20in%20a%20rainy%20cyberpunk%20city%20street%2C%20orange%20and%20teal%20neon%20reflections%20on%20wet%20asphalt%2C%20silhouetted%20pilot%20in%20foreground%2C%20dramatic%20low%20angle%2C%20cinematic%20wide%20shot%20with%20dark%20sky%20for%20text%20overlay&width=1920&height=900&seq=anime-hero-03&orientation=landscape",
    tags: ["科幻", "机甲"],
    rating: 8.8,
  },
];

export const animeCategories = [
  { name: "热血", icon: "ri-fire-line" },
  { name: "恋爱", icon: "ri-heart-3-line" },
  { name: "科幻", icon: "ri-rocket-2-line" },
  { name: "奇幻", icon: "ri-magic-line" },
  { name: "治愈", icon: "ri-cup-line" },
  { name: "悬疑", icon: "ri-search-eye-line" },
  { name: "运动", icon: "ri-basketball-line" },
  { name: "日常", icon: "ri-sun-line" },
];

export const animeRegions = ["日本", "中国", "美国"];

export const animeYears = [2026, 2025, 2024, 2023];